/**
 * What the Turnstile widget does after a failed challenge (error-callback, e.g. code 600010 when
 * a browser blocks part of the check). It retries quietly a few times, then asks the visitor to
 * retry by hand, so a failure never leaves the submit button disabled without a word.
 */
export const TURNSTILE_AUTO_RETRIES = 2;
export const TURNSTILE_RETRY_DELAY_MS = 1500;

/** `failures` is the number of consecutive failures, including this one. */
export function turnstileFailureAction(failures: number): 'retry' | 'ask' {
  return failures <= TURNSTILE_AUTO_RETRIES ? 'retry' : 'ask';
}
